/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateShopMemberOrderDto } from '../../models/create-shop-member-order-dto';
import { ShopOrder } from '../../models/shop-order';

export interface ShopControllerCreateMemberOrder$Params {
  id: number;
      body: CreateShopMemberOrderDto
}

export function shopControllerCreateMemberOrder(http: HttpClient, rootUrl: string, params: ShopControllerCreateMemberOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrder>> {
  const rb = new RequestBuilder(rootUrl, shopControllerCreateMemberOrder.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrder>;
    })
  );
}

shopControllerCreateMemberOrder.PATH = '/api/shop/{id}/order';
